import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/lbc66/app/[locale]/(unauthorized)/login/page.client.tsx");
